import { apiUrl } from '../../../config/api';
export async function fetchHistorialData() {
    const response = await fetch(apiUrl('historial'));

    if (!response.ok) {
        throw new Error(`Error al cargar historial (${response.status})`);
    }

    const payload = await response.json();

    if (typeof payload === 'string') {
        return JSON.parse(payload);
    }

    return payload;
}
